<td>
  <span class="flex gap-2 align-items-center">
    @if (item.icon) {
      <app-svg-icon [key]="item.icon" />
    } @else {
      <i class="fa-regular fa-map"></i>
    }
    {{ item.name }}
  </span>
</td>
<td>
  <span class="flex gap-2">
    @if (actions.includes('generateView')) {
      <p-button
        class="ml-auto"
        pTooltip="Im Atlas anzeigen"
        styleClass="p-button-xs"
        (click)="generateView(item)"
        [rounded]="true"
        icon="fas fa-eye"></p-button>
    }
    @if (item.type === 'Point' && actions.includes('addPoi')) {
      <p-button
        pTooltip="In Karten hinzufügen"
        styleClass="p-button-xs"
        (click)="addPoi(item._id)"
        [rounded]="true"
        icon="fas fa-map-location-dot"></p-button>
    }
    @if (actions.includes('select')) {
      <p-button
        styleClass="p-button-xs"
        (click)="select(item)"
        [rounded]="true"
        icon="fas fa-hand-pointer"></p-button>
    }
    @if (actions.includes('edit')) {
      <a
        pButton
        class="p-button-xs"
        (click)="closeParent()"
        [routerLink]="[{ outlets: { bearbeiten: ['raum', item._id] } }]"
        [rounded]="true"
        icon="fas fa-pen"></a>
    }
  </span>
</td>
